import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Select from 'react-select';

const useStyle = makeStyles(() => ({
  select_placeholder:{
    color:'#000 !important' ,
  }
}));
const customStyles = {
  root: {
    color: '#4CAF50',
    backgroundColor: '#4CAF50',
    cursor:'pointer',
  },
  control: (props) => ({
    ...props,
    borderRadius: '100px',
    boxShadow: 'none',
    borderColor: '#000',
    height:48,
    cursor:'pointer',
    '&:focus': {
      outline: 'none',
      borderColor: '#4CAF50',
      color:'#fff'
    },
    '&:hover': {
      borderColor: '#4CAF50'
    }
  }),
  indicatorSeparator: () => ({
    width: 0
  }),
  container: () => ({
    maxWidth: '110px',
    width: '100%',
    cursor:'pointer',
  }),
  option: (props) => ({
    ...props,

    cursor:'pointer',
    // backgroundColor:'yellow',
    '&:hover': {
      backgroundColor: '#4CAF50',
      color: '#fff'
    },
    '&:before': {
      backgroundColor: '#4CAF50',
      color: '#fff'
    },
  }),
  menu: (props) => ({
    ...props,
    maxWidth: '110px',
    borderRadius: '20px',
    margin: 0,
    top: 'none',
    cursor:'pointer',
  }),
  menuList: (props) => ({
    ...props,
    borderRadius: 20,
    padding: 0,
    cursor:'pointer',
  }),
  dropdownIndicator:(props)=>({
    ...props,
    '& svg':{
      right:'0 !important' ,
      color:'#000'
    }
  }),
  valueContainer:(props)=>({
    ...props,
    height:48,
  }),
};
const StyledSelect = (props) => {
  const propsProduct = props?.product ? props.product : null;
  const classes = useStyle();

  const options = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
  ];

  const fiatOptions = [
    { value: 1, label: '$25' },
    { value: 2, label: '$50' },
    { value: 4, label: '$100' },
    { value: 6, label: '$150' },
    { value: 10, label: '$250' },
    { value: 20, label: '$500' },

  ]

  const handleChange = (e) => {
      props.updateProductQuantity(propsProduct?.id, e.value)
  }

  return (
    <Select
      styles={customStyles}
      placeholder={props.mode == 'fiat' && propsProduct.id !== 'a7405ba7-bfea-41b8-a184-53281107a815' ? <span className={classes.select_placeholder}>$25</span>: <span className={classes.select_placeholder}>1</span>}
      options={ props.mode == 'fiat' && propsProduct.id !== 'a7405ba7-bfea-41b8-a184-53281107a815' ? fiatOptions :  options}
      onChange={e => handleChange(e)}
      theme={theme => ({
        ...theme,
        borderRadius: 0,
        colors: {
          ...theme.colors,
          primary25: '#4CAF50',
          primary: '#4CAF50',
        },
      })}
    >
    </Select>

  );
};

export default StyledSelect;